import axios from "axios";
import params from "../../../config/params";

require("dotenv").config();

let BASE_URL = params.PROD.BACK_OFFICE.REQUEST_APPROVAL.REQUEST_APPROVAL.BASE_URL;

if (process.env.NODE_ENV === "development") {
  BASE_URL = params.DEV.BACK_OFFICE.REQUEST_APPROVAL.REQUEST_APPROVAL.BASE_URL;
}
if (process.env.NODE_ENV === "qa") {
  BASE_URL = params.QA.BACK_OFFICE.REQUEST_APPROVAL.REQUEST_APPROVAL.BASE_URL;
}

const getPolicyFile = () => {
  return axios.get(`${BASE_URL}/policy`)
};

export default {
  getPolicyFile,
};
